import { styled } from "styled-components";

export const StyledText = styled.span`
  font-size: ${({ style }) => style?.fontSize};
  font-weight: ${({ style }) => style?.fontWeight};
  color: ${({ style }) => style?.color};
  letter-spacing: ${({ style }) => style?.letterSpacing || "0px"};
  white-space: pre-line;
`;
